import type { ComparisonDetail } from "../../../shared/contracts/product-pages.js";
import type { RivalInsight } from "../../../shared/presentation/rival-insight.js";
import { sourceDate, teePairLabel } from "./comparison-selection.js";
import { InsightNumbers } from "../insights/rival-insights-carousel.js";

/** Only the selected insight's qualified source rounds, never unrelated history. */
export function InsightEvidence(props: {
  finding: RivalInsight;
  detail: ComparisonDetail;
  onOpenRoundId?(id: string): void;
}): React.JSX.Element {
  const sources = props.detail.sources.filter((source) =>
    props.finding.sourceRoundIds.includes(source.roundId),
  );
  return (
    <section
      className="rc-finding fr-selected-insight"
      aria-label="Selected insight"
    >
      <InsightNumbers finding={props.finding} />
      <details className="rc-evidence">
        <summary>See these rounds ({sources.length})</summary>
        {sources.map((source) => (
          <p key={source.roundId}>
            {props.onOpenRoundId ? (
              <button
                type="button"
                className="rc-text-button"
                onClick={() => props.onOpenRoundId?.(source.roundId)}
              >
                {source.courseName} · {sourceDate(source)}
              </button>
            ) : (
              <span>
                {source.courseName} · {sourceDate(source)}
              </span>
            )}
            <small className="rc-note"> · {teePairLabel(source.teePair)}</small>
          </p>
        ))}
        {sources.length !== props.finding.sourceRoundIds.length ? (
          <p className="rc-note">
            Some source rounds are no longer available. Open the shared record
            for current evidence.
          </p>
        ) : null}
      </details>
    </section>
  );
}
